import React from "react";
import { useTranslation } from 'react-i18next';

const DonarCard = ({
  donationImage,
  donorName,
  amount,
  description,
}) => {
  const { i18n } = useTranslation();

  // Default labels based on language
  const roleLabel = i18n.language === 'mr' ? 'देणगीदाराचे नाव' : 'Donor Name';
  const amountLabel = i18n.language === 'mr' ? 'रक्कम' : 'Amount';
  return (
    <div className="border rounded-md border-[#DDDDDD] bg-white">
      <img
        src={donationImage}
        alt="Donor"
        className="w-full object-cover rounded-t-md"
      />
      <div className="p-4 flex flex-col">
        <div className="flex items-center gap-3 mb-3">
          <div className="flex flex-col items-start justify-start gap-2">
            <h2 className="text-[#212121] text-[14px] font-medium m-0">{roleLabel}</h2>
            <p className="text-[var(--color-primary)] text-[20px] font-semibold m-0">{donorName}</p>
          </div>
        </div>
        <p className="text-[#212121] text-[14px] font-medium m-0 mb-1">{amountLabel}</p>
        <h3 className="text-[var(--color-primary)] text-[20px] font-semibold mb-3">{amount}</h3>
        <p className="text-sm font-normal m-0">
          {description}
        </p>
      </div>
    </div>
  );
};

export default DonarCard;
